import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

export const validateLoginTokenSlice = createSlice({
  name: "validateLoginToken",
  initialState: {
    isLoading: false,
    isError: false,
    data: {},
    error: {},
    message: "",
    enrolledData: [],
    status_code: null,
  },
  reducers: {
    onValidateLoginTokenSubmit: (state) => {
      return {
        ...state,
        isLoading: true,
        isError: false,
        data: {},
        message: "",
      };
    },

    onValidateLoginTokenSuccess: (state, { payload }) => {
      const { data = {}, message = "", status_code = 200 } = payload;
      // console.log("ValidateLoginTokenSuccess payload:", payload);
      Cookies.set('xid', data?.encryptedMemberIdentifier, { expires: 7, secure: true });
      return {
        ...state,
        isLoading: false,
        isError: false,
        data,
        message,
        status_code
      };
    },

    onValidateLoginTokenError: (state, { payload }) => {
      const { data = {}, message = "", status_code = 400 } = payload;
      return {
        ...state,
        data,
        message,
        status_code,
        isLoading: false,
        isError: true,
      };
    },
    onValidateLoginTokenReset: (state) => {
      return {
        ...state,
        message: "",
        status_code: null,
        isLoading: false,
        isError: false,
      };
    },
    onValidateLoginTokenLogout: () => {
      Cookies.remove('xid');
      return validateLoginTokenSlice.getInitialState();
    },
    onEnrolledSubmit: (state) => {
      return {
        ...state,
        isLoading: true,
        isError: false,
        enrolledData: {},
        message: "",
      };
    },

    onEnrolledSuccess: (state, { payload }) => {
      const { enrolledData = {}, message = "", status_code = 200 } = payload;
      const mergedData = {
        ...state.data,
        ...enrolledData,
      };
      return {
        ...state,
        isLoading: false,
        isError: false,
        enrolledData,
        data: mergedData,
        message,
        status_code,
      };
    },

    onEnrolledError: (state, { payload }) => {
      const { enrolledData = {}, message = "", status_code = 400 } = payload;
      return {
        ...state,
        enrolledData,
        message,
        status_code,
        isLoading: false,
        isError: true,
      };
    },
    onEnrolledReset: (state) => {
      return {
        ...state,
        message: "",
        enrolledData: {},
        status_code: null,
        isLoading: false,
        isError: false,
      };
    },
  },
});
export const { onValidateLoginTokenSubmit, onValidateLoginTokenSuccess, onValidateLoginTokenError, onValidateLoginTokenReset, onValidateLoginTokenLogout, onEnrolledSubmit, onEnrolledSuccess, onEnrolledError, onEnrolledReset } =
  validateLoginTokenSlice.actions;

export default validateLoginTokenSlice.reducer;
